export class HttpResponseError extends Error {
    name = 'NotOKHttpResponseError';

    code: number;

    url?: string;

    body?: any;

    method?: string;

    status?: number;

    errorMessage?: string;

    constructor(message: string, code: number, url?: string, body?: any) {
        super(message);
        this.code = code;
        this.url = url;
        this.body = body;
    }
}
